import type { CSSProperties } from 'react'
import { blockTheme } from '../block-theme/blockTheme'
import { cn } from '../lib/utils'
import { uiText } from '../i18n'
import { PRESSABLE_CLASS } from './pressable'

const TEXT = {
  ru: { back: 'Предыдущий блок' },
  en: { back: 'Previous block' },
}

const q = blockTheme.quiz
/** `--color-violet-dark` плеера — оттенок стрелки. */
const VIOLET_DARK = '#924cfe'

// Как у погашенной CTA: светло-серая пилюля с бликом и кромкой `mutedInk` —
// нейтрально рядом с «Далее» любого цвета. Стрелка серая с еле заметным
// фиолетовым оттенком (плеер: `--block-muted-text` 75% + violet-dark).
const LOOK = {
  backgroundColor: q.muted,
  backgroundImage: q.gloss,
  color: `color-mix(in srgb, ${q.mutedText} 75%, ${VIOLET_DARK})`,
  '--cta-ink': q.mutedInk,
  '--cta-glow': 'transparent',
} as CSSProperties

interface LessonBackButtonProps {
  onClick?: () => void
  className?: string
}

/**
 * LessonBackButton — «назад» к предыдущему блоку слева от нижней CTA урока, как
 * в плеере (academy-frontend `LessonBackButton` → `BackButton` lg pressable):
 * круг 48px на той же 6px-кромке, что и «Далее», стрелка влево.
 */
export const LessonBackButton = ({ onClick, className }: LessonBackButtonProps) => {
  const label = uiText(TEXT).back
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      className={cn(PRESSABLE_CLASS, 'grid h-12 w-12 shrink-0 place-items-center', className)}
      style={LOOK}
    >
      <svg className="h-5 w-5" viewBox="0 0 14 14" fill="none" aria-hidden>
        <path
          d="M9.33 2.62 4.67 6.71l4.66 4.08"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
